import { useEffect, useState } from "react";
import api from "@/lib/api";
import { WarningCircle } from "@phosphor-icons/react";

// Rendu réel (serveur) de l'email pour un destinataire choisi : variables remplacées + pied de page d'opposition.
export function PreviewPanel({ cid, recipients, draft, testid = "lead-preview" }) {
  const [key, setKey] = useState(recipients[0]?.key || "");
  const [pv, setPv] = useState(null);
  useEffect(() => { setKey((k) => (recipients.some((r) => r.key === k) ? k : recipients[0]?.key || "")); }, [recipients]);
  useEffect(() => {
    api.post(`/admin/leads/campaigns/${cid}/preview`, { key: key || undefined, ...(draft || {}) }).then(({ data }) => setPv(data)).catch(() => setPv(null));
  }, [cid, key, draft]);
  return (
    <div className="space-y-2" data-testid={testid}>
      <div className="flex flex-wrap items-center gap-2 text-xs">
        <span className="text-muted">Aperçu pour :</span>
        {recipients.length ? (
          <select value={key} onChange={(e) => setKey(e.target.value)} className="bg-surface-2 border border-border rounded-md px-2 py-1 max-w-full" data-testid={`${testid}-recipient`}>
            {recipients.map((r) => <option key={r.key} value={r.key}>{r.contact_name || r.email} — {r.company} ({r.email})</option>)}
          </select>
        ) : <span className="text-muted">un contact fictif (aucun destinataire sélectionné)</span>}
      </div>
      {pv && (
        <>
          <div className="text-xs"><span className="text-muted">À : </span><span className="text-fg font-mono">{pv.to || "(exemple)"}</span></div>
          <div className="text-sm text-fg"><span className="text-xs text-muted">Objet : </span><span data-testid={`${testid}-subject`}>{pv.subject}</span></div>
          {pv.unknown_variables?.length > 0 && <p className="text-xs text-destructive flex gap-1" data-testid={`${testid}-unknown`}><WarningCircle size={14} className="shrink-0" /> Variables inconnues (seront vides) : {pv.unknown_variables.map((v) => `{{${v}}}`).join(", ")}</p>}
          {pv.empty_variables?.length > 0 && <p className="text-xs text-amber-500 flex gap-1" data-testid={`${testid}-empty-vars`}><WarningCircle size={14} className="shrink-0" /> Pour ce contact, {pv.empty_variables.map((v) => `{{${v}}}`).join(", ")} est vide : vérifiez la formulation.</p>}
          <div className="bg-white text-black rounded p-4 text-sm lead-email-render" data-testid={`${testid}-html`} dangerouslySetInnerHTML={{ __html: pv.html }} />
        </>
      )}
    </div>
  );
}
